"use client";

import { useEffect, useState } from "react";

function slugify(text:string){
  return text.toLowerCase().replace(/\s+/g,"-");
}

export default function BlogTOC({ content }: any) {

  const headings = content
    .filter((c:any)=>c.type==="heading")
    .map((c:any)=>c.text);

  const [active,setActive]=useState("");

  useEffect(()=>{

    const handler=()=>{

      let current="";

      headings.forEach((h:string)=>{
        const el=document.getElementById(slugify(h));
        if(!el) return;

        if(el.getBoundingClientRect().top<=120){
          current=slugify(h);
        }
      });

      setActive(current);
    };

    window.addEventListener("scroll",handler);
    return()=>window.removeEventListener("scroll",handler);

  },[headings]);

  return (
    <aside className="hidden lg:block sticky top-4 h-fit">

      <div className="bg-white border rounded-2xl p-6 shadow">

        <h3 className="font-bold mb-4">
          Table of Contents
        </h3>

        <ul className="space-y-2 text-sm">

          {headings.map((h:string)=>{

            const id=slugify(h);

            return(
              <li key={id}>
                <a
                  href={`#${id}`}
                  className={`block ${
                    active===id
                    ?"text-emerald-600 font-semibold"
                    :"text-gray-600"
                  }`}
                >
                  {h}
                </a>
              </li>
            )

          })}

        </ul>

      </div>

    </aside>
  );
}